export const gradovi = [
  { label: "Split", value: "Split" },
  { label: "Zagreb", value: "Zagreb" },
  { label: "Ljubljana", value: "Ljubljana" },
  { label: "Beograd", value: "Beograd" },
  { label: "Podgorica", value: "Podgorica" },
  { label: "Rijeka", value: "Rijeka" },
  { label: "Online", value: "Online" },
];
